/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, Input, OnChanges} from '@angular/core';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import * as _ from 'lodash';
import * as moment from 'moment';
import 'moment-timezone';

import {formatAdnStat} from '../../common/filters/format-adn-stat';
import {AppLocaleService} from '../../common/locale/app-locale.service';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {APP_SHARED} from '../../common/app-shared';

@Component({
  standalone: true,
  imports: [...APP_SHARED, TranslateModule],
  selector: 'adn-objectives-view-component',
  template: `
    <div *ngFor="let obj of objs">
      <small>{{ obj.label }}: </small><span>{{ obj.val | displayStat }}</span>
    </div>
    <div *ngIf="lineItem?.type === 'SPONSORSHIP'">SoV: {{ lineItem.sponsorshipPercentage }}%</div>
    <div *ngIf="budget">{{ formatStat(budget.amount) }} to {{ budget.endDay | localeDate:'shortDate' }}</div>
  `
})
export class ObjectivesViewComponent implements OnChanges {
  @Input() lineItem: any;

  objs: Array<{label: string; val: any}> = [];
  budget: any;

  constructor(
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any,
    private readonly translate: TranslateService,
    private readonly appLocale: AppLocaleService
  ) {
  }

  ngOnChanges(): void {
    this.refresh();
  }

  formatStat(value: any): string {
    return formatAdnStat(value, undefined, undefined, undefined, this.LocalNetworkProfile.get('defaultCurrency'), this.appLocale.getLocaleId());
  }

  private refresh(): void {
    if (!this.lineItem) {
      this.objs = [];
      this.budget = null;
      return;
    }

    this.objs = _.map(_.cloneDeep(this.lineItem.objectives) || {}, (val, key) => {
      const transKey = 'lineItem.objective.' + key + '.list';
      const trans = this.LocalNetworkProfile.getNetworkTranslations(transKey);
      return {label: trans || this.translate.instant(transKey), val};
    });

    const nwTz = this.LocalNetworkProfile.get('timeZone');
    const now = moment();
    this.budget = _.find(this.lineItem.budget, (b: any) => {
      return (moment.tz(b.startDay, nwTz).startOf('day').isBefore(now)
          || moment.tz(b.startDay, nwTz).startOf('day').diff(moment.tz(this.lineItem.startDate, nwTz).startOf('day'), 'minutes') < 120)
        && moment.tz(b.endDate, nwTz).endOf('day').isAfter(now);
    });
  }
}
